import styled from 'styled-components'

export const StyledVolumesQueriesGrid = styled.div`
  .queryLink {
    font-size: 14px;
  }
`
